import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Button from "react-bootstrap/Button"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import Container from "react-bootstrap/Container"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHeart } from "@fortawesome/free-solid-svg-icons"

const BeAMentorSection1Background = styled.div`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.gray_dark};
  font: 20px/28px Roboto;
  min-height: 669px;
  @media (max-width: 767px) {
    min-height: 0;
    padding-top: 50px;
    overflow: hidden;
  }
`

const BeAMentorSection1Title = styled.div`
  font: 58px/62px Abril Fatface;
  margin-bottom: 35px;
  min-height: 132px;
  @media (max-width: 1199px) {
    font: 56px/60px Abril Fatface;
  }
  @media (max-width: 767px) {
    font: 2.5rem/3rem Abril Fatface;
    margin-bottom: 17.5px;
  }
  @media (min-width: 992px) {
    padding-top: 116px;
  }
`

const SectionItem = styled.div`
  display: inline-block;
  @media (max-width: 767px) {
    margin-top: 0;
    margin-bottom: 0px;
  }
`

const BulletCol = styled(Col)`
  .row {
    margin-bottom: 20px;
  }
`

const FAHeart = styled(FontAwesomeIcon)`
  font-size: 1rem;
  color: ${props => props.theme.colors.accent_yellow_hover};
`

const ButtonFill6 = styled(Button)`
  height: 60px;
  color: ${props =>
    props.theme.buttons.primary_button_violet.normal.color} !important;
  background-color: ${props =>
    props.theme.buttons.primary_button_violet.normal
      .background_color} !important;
  border-color: ${props =>
    props.theme.buttons.primary_button_violet.normal.border_color} !important;
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props =>
      props.theme.buttons.primary_button_violet.hovered.color} !important;
    background-color: ${props =>
      props.theme.buttons.primary_button_violet.hovered
        .background_color} !important;
    border-color: ${props =>
      props.theme.buttons.primary_button_violet.hovered
        .border_color} !important;
    box-shadow: 0px 3px 20px
      ${props => props.theme.buttons.primary_button_violet.hovered.shadow} !important;
    @media (min-width: 1199px) {
      margin-top: -3px;
      margin-bottom: 3px;
    }
  }
  &:focus,
  &.focus,
  &:active,
  &.active {
    color: ${props =>
      props.theme.buttons.primary_button_violet.pressed.color} !important;
    background-color: ${props =>
      props.theme.buttons.primary_button_violet.pressed
        .background_color} !important;
    border-color: ${props =>
      props.theme.buttons.primary_button_violet.pressed
        .border_color} !important;
    box-shadow: none !important;
    @media (min-width: 1199px) {
      margin-top: -3px;
      margin-bottom: 3px;
    }
  }
  @media (max-width: 921px) {
    width: 100%;
    margin-bottom: 20px;
  }
  @media (max-width: 767px) {
    width: 100%;
  }
`
const ButtonOutline1 = styled(Button)`
  height: 60px;
  color: ${props =>
    props.theme.buttons.secondary_big_button_violet.normal.color};
  background-color: transparent !important;
  border-color: ${props =>
    props.theme.buttons.secondary_big_button_violet.normal.border_color};
  font: 22px/22px Roboto;
  transition: 0.25s ease-out;
  &:hover {
    color: ${props =>
      props.theme.buttons.secondary_big_button_violet.hovered.color} !important;
    background-color: ${props =>
      props.theme.buttons.secondary_big_button_violet.hovered
        .background_color} !important;
    border-color: ${props =>
      props.theme.buttons.secondary_big_button_violet.hovered
        .border_color} !important;
    box-shadow: 0px 3px 20px
      ${props => props.theme.buttons.secondary_big_button_violet.hovered.shadow} !important;
    @media (min-width: 1199px) {
      margin-top: -3px;
      margin-bottom: 3px;
    }
  }
  &:focus,
  &.focus,
  &:active,
  &.active {
    color: ${props =>
      props.theme.buttons.secondary_big_button_violet.hovered.color} !important;
    background-color: ${props =>
      props.theme.buttons.secondary_big_button_violet.pressed
        .background_color} !important;
    border-color: ${props =>
      props.theme.buttons.secondary_big_button_violet.pressed
        .border_color} !important;
    box-shadow: none !important;
    @media (min-width: 1199px) {
      margin-top: -3px;
      margin-bottom: 3px;
    }
  }
  @media (min-width: 922px) {
    margin-left: 25px;
  }
  @media (max-width: 921px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 50px;
  }
`

const BgCol5 = styled(Col)`
  :before {
    background-image: url("/page-womenbiz-for-leaders-section1-img1.png");
    content: "";
    display: block;
    position: absolute;
    width: 567px;
    height: 700px;
    top: 40px;
    right: -140px;
    z-index: 3;
  }
  @media (max-width: 1199px) {
    :after {
      top: 435px;
      right: 50px;
    }
  }
  @media (max-width: 991px) {
    :after {
      display: none;
    }
    :before {
      display: none;
    }
  }
  @media (max-width: 767px) {
    :before {
      display: none;
    }
    :after {
      display: block;
      width: 300px;
      height: 300px;
      top: -415px;
      left: 73px;
      background-position: center;
    }
  }
  @media (max-width: 374px) {
    :after {
      width: 280px;
    }
  }
  @media (max-width: 359px) {
    :after {
      width: 240px;
    }
  }
`

const bulletedContents = [
  "Upskill your talents through thematic seminars lead by WomenWorks mentor as a speaker",
  "Boost your employer branding through events collaboration with us! Attract more high-quality female talents through Webinar with experts from WomenWorks and your company",
  "For a more soft-selling approach of your brand, WomenWorks provides collaborative content creation through our highly-engaged social media such as Instagram live sessions, Instagram posts, women leadership highlights and many more..",
]

const PledgePanel = styled.div`
  border: 1px solid #d9c894;
  font-size: 16px;
  line-height: 22px;
  background-color: ${props => props.theme.colors.accent_yellow70};
  min-height: 217px;
  width: 100%;
  margin-top: 170px;
  padding: 40px 30px 52px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 991px) {
    margin-top: 50px;
    margin-bottom: 0px;
  }
`
const UrlLink = styled(OutboundLink)`
  color: ${props => props.theme.colors.primary_violet};
  text-decoration: underline;
  &:hover {
    font-weight: bold;
    color: ${props => props.theme.colors.primary_violet};
  }
`
export default function BookASpeakerSection1(props) {
  return (
    <BeAMentorSection1Background>
      <Container>
        <SectionItem>
          <BgCol5 />
          <Row>
            <Col xs="12" lg="8">
              <BeAMentorSection1Title>
                Book us to speak at your event!
              </BeAMentorSection1Title>
            </Col>
            <Col xs="12" lg="4">
              <img
                alt="WomenWorks - two young woman working together"
                src="/page-be-a-mentor-section2-img1.png"
                css={css`
                  @media (max-width: 767px) {
                    width: 100%;
                    margin-bottom: 15px;
                  }
                  @media (min-width: 768px) {
                    object-fit: cover;
                    height: 250px;
                    width: 100%;
                    margin-bottom: 30px;
                    object-position: 10% 10%;
                  }
                  @media (min-width: 992px) {
                    display: none;
                  }
                `}
              ></img>
            </Col>
            <BulletCol xs="12" lg="7">
              {bulletedContents.map(item => (
                <Row>
                  <Col
                    xs="auto"
                    css={css`
                      padding-right: 0;
                    `}
                  >
                    <FAHeart icon={faHeart} />
                  </Col>
                  <Col
                    css={css`
                      padding-left: 7px;
                    `}
                  >
                    {item}
                  </Col>
                </Row>
              ))}
            </BulletCol>
            <Col xs="12" lg="8">
              <OutboundLink
                id="BookaSpeaker-BookUsNow-Button"
                target="_blank"
                rel="noreferrer"
                href={"mailto:krinta@womenworks.io" +
                "?cc=yours@womenworks.io"+
                "&subject=I%20Want%20to%20Invite%20a%20Ladyboss%20Speaker" +
                "&body=Dear%20WomenWorks%20team,%0D%0A%0D%0A"+
                "We're%20interested%20to%20invite%20speakers%20for%20our%20[event/program%20name]%20on%20the%20[estimated%20month%20of%20event].%20Please%20find%20below%20our%20contact%20information%20where%20you%20can%20reach%20us%20to%20discuss%20further.%0D%0A%0D%0A" +
                "Name%20:%0D%0A" +
                "Company%20:%0D%0A" +
                "Mobile%20:%0D%0A" +
                "Professional%20Email%20:%0D%0A%0D%0A" +
                "Thank%20you!"}
              >
                <ButtonFill6>Book us now</ButtonFill6>
              </OutboundLink>
              <Link id="BookaSpeaker-GettoKnowOurMentors-Button" to="/the-ladybosses/">
                <ButtonOutline1>Get to know our mentors</ButtonOutline1>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col>
              <PledgePanel>
                <Row
                  css={css`
                    align-items: center;
                    @media (max-width: 767px) {
                      display: block;
                      margin-left: auto;
                      margin-right: auto;
                    }
                  `}
                >
                  <Col
                    xs="auto"
                    css={css`
                      @media (max-width: 506px) {
                        margin-left: auto;
                        margin-right: auto;
                        margin-bottom: 50px;
                      }
                      @media (max-width: 767px) {
                        margin-bottom: 20px;
                        display: flex;
                        justify-content: center;
                      }
                    `}
                  >
                    <img
                      css={css`
                        height: 125px;
                        width: 125px;
                      `}
                      alt="icon"
                      src="/page-masterclass-section3-icon1.svg"
                    />
                  </Col>
                  <Col
                    css={css`
                      height: fit-content;
                      
                      @media (max-width: 506px) {
                        text-align: center;
                      }
                    `}
                  >
                    As aligned with SDG 5, Gender Equality, WomenWorks is
                    working to support development towards no-all-male-panels.
                    The “No-Manel Pledge” is not just about putting women on
                    panels or as speakers. It is also about diversity across
                    intersectionality. It sets the stage for inclusivity that
                    considers gender, race, sexual orientation, class,
                    disability, geography, and language.
                    <br />
                    <br />
                    Read more here:{" "}
                    <UrlLink
                      target="_blank"
                      rel="noreferrer"
                      href="https://indonesia.un.org/en/130275-guidance-avoiding-all-male-panels"
                    >
                      https://indonesia.un.org/en/130275-guidance-avoiding-all-male-panels
                    </UrlLink>
                  </Col>
                </Row>
              </PledgePanel>
            </Col>
          </Row>
        </SectionItem>
      </Container>
    </BeAMentorSection1Background>
  )
}
